import React from 'react';
import { cn } from '../lib/utils';

export const StatCard = ({ title, value, icon: Icon, trend, className }) => {
  return (
    <div className={cn("bg-white rounded-xl p-6 border border-slate-200 shadow-sm hover:shadow-md transition-shadow", className)}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm font-medium text-slate-600 mb-1">{title}</p>
          <h3 className="text-3xl font-bold text-slate-900">{value}</h3>
          {trend && (
            <p className={cn(
              "text-sm mt-2",
              trend.positive ? "text-green-600" : "text-red-600"
            )}>
              {trend.value}
            </p>
          )}
        </div>
        {Icon && (
          <div className="p-3 bg-primary/10 rounded-lg">
            <Icon className="w-6 h-6 text-primary" />
          </div>
        )}
      </div>
    </div>
  );
};